export default "__VITE_ASSET__CbOynzt9__"